import {
  Button,
  Col,
  Divider,
  Form,
  Image,
  Input,
  Row,
  Select,
  Spin,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  EditOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../Utils";
import dropDownImage from "../../../Assets/ChevronDown.png";
import { JsonEditor } from "json-edit-react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { IoAddOutline, IoMenu } from "react-icons/io5";
import { addCasino, editCasino, uploadImage } from "./CasinoAPI";
function UpdateCasino() {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [contentData, setContentData] = useState({});
  const [imageLoader, setImageLoader] = useState(false);
  const [imageURL, setImageURL] = useState(from === "add" ? "" : fill.image);
  const [isLoading, setIsLoading] = useState(false);
  console.log(from, fill);
  const handleFileUpload = useCallback(
    async (e) => {
      try {
        setImageLoader(true);
        const { files } = e.target;
        const response = await uploadImage(files);
        const url = response?.data?.url;
        setImageURL(url);
      } catch (error) {
        console.log({ error });
      } finally {
        setImageLoader(false);
      }
    },
    [contentData]
  );

  //   function FetchContentDataByID() {
  //     getOfferbyId(`${fill?._id}`)
  //       .then((response) => {
  //         if (response.success) {
  //           setContentData(response.data.content);
  //           form.setFieldsValue(response.data.content);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("error", err);
  //       });
  //   }

  //   const setJSONData = () => {};

  //   useEffect(() => {
  //     FetchContentDataByID();
  //   }, [form]);

  const navigate = useNavigate();
  const AddCasino = (values) => {
    console.log(values);
    const payload = {
      link: values.link,
      isActive: values.isActive,
      pageNumber: values.pageNumber,
      image: imageURL,
    };

    setIsLoading(true);
    addCasino(payload)
      .then((response) => {
        if (response.status) {
          navigate("/get/casino_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  const updateContentData = (values) => {
    console.log(values);
    const payload = {
      link: values.link,
      isActive: values.isActive,
      pageNumber: values.pageNumber,
      image: imageURL,
    };

    setIsLoading(true);

    editCasino(payload, `${fill?._id}`)
      .then((response) => {
        if (response.status) {
          navigate("/get/casino_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (fill) {
      form.setFieldsValue({
        pageNumber: fill.pageNumber,
        link: fill.link,
        isActive: fill.isActive,
        image: fill.image,
      });
    }
  }, [form, fill]);
  return (
    <div>
      <Divider
        orientation="left"
        style={{ border: "#cecece" }}
        className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
      >
        {from === "edit" ? "Update" : "Add"} Casino
      </Divider>
      <Form
        className="bg-white mt-6"
        layout="vertical"
        onFinishFailed={(err) => {
          err?.errorFields?.forEach((field) => {
            field.errors?.forEach((error) => {
              dispatchtoast(error, true);
            });
          });
        }}
        onFinish={(values) =>
          from === "add" ? AddCasino(values) : updateContentData(values)
        }
        form={form}
        ref={formRef}
        initialValues={
          from === "edit"
            ? contentData
            : {
                meta: [{ name: "Title", content: "" }],
                components: [{ heading: "", paragraph: [] }],
              }
        }
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Page Number
                </p>
              }
              name="pageNumber"
            >
              <Input
                placeholder="e.g.,pageNumber should be greater then 0"
                type="number"
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Link
                </p>
              }
              name="link"
            >
              <Input placeholder="e.g.,Your go-to source for course tips, updates, and success stories." />
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Active Status
                </p>
              }
              name="isActive"
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Select
                placeholder="True"
                suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}
              >
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col>
            {" "}
            <Form.Item
              name="image"
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-0.01em]">
                  {from === "edit" ? "Content image" : "Add image"}
                </p>
              }
            >
              <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                {imageLoader ? (
                  <Spin />
                ) : (
                  <>
                    {imageURL ? (
                      <Image
                        src={imageURL}
                        height={127}
                        style={{
                          objectFit: "cover",
                          borderRadius: "11px",
                        }}
                        preview={false}
                      />
                    ) : (
                      ""
                    )}

                    <input
                      type="file"
                      name="photo"
                      id="upload-photo"
                      onChange={handleFileUpload}
                      className="hidden"
                    />

                    <label
                      htmlFor="upload-photo"
                      className="absolute bottom-2 right-2 cursor-pointer"
                    >
                      {from === "edit" ? (
                        <EditOutlined className="w-[22px] h-[22px] bg-red-600 text-white rounded-full flex items-center justify-center text-xs opacity-80" />
                      ) : (
                        <IoAddOutline className="w-[26px] h-[26px] bg-red-600 text-white rounded-full flex items-center justify-center text-xs opacity-80" />
                      )}
                    </label>
                  </>
                )}
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row className="flex justify-between">
          <Form.Item>
            <Button
              onClick={() => {
                from === "edit"
                  ? navigate("/blog/blogData")
                  : form.resetFields();
              }}
              className="RemoveButtonHover cancel-button"
              size="small"
              htmlType="onSubmit"
            >
              Cancel
            </Button>
          </Form.Item>

          <Form.Item>
            <Button
              className="NoButtonHover create-button"
              size="small"
              htmlType="submit"
              loading={isLoading}
            >
              {from === "edit" ? "Edit" : "Create"} Casino
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default UpdateCasino;
